"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLAIM_REJECTION_APPEALABLE_REJECTION_REASONS = exports.DROPSHIP_ORDER_VALID_CLAIM_REASONS = void 0;
const Claim_1 = require("../src/common/Claim");
const ClaimRejectionReason_1 = require("./ClaimRejectionReason");
exports.DROPSHIP_ORDER_VALID_CLAIM_REASONS = [
    Claim_1.ClaimReason.INCORRECT_PRODUCT,
    Claim_1.ClaimReason.MISSING_PRODUCT,
];
exports.CLAIM_REJECTION_APPEALABLE_REJECTION_REASONS = [
    ClaimRejectionReason_1.RejectionReason.INSUFFICIENT_PROOF_OF_CUSTOMER_COMMUNICATION,
    ClaimRejectionReason_1.RejectionReason.INSUFFICIENT_PROOF_OF_WHOLESALE_COST,
    ClaimRejectionReason_1.RejectionReason.INCORRECT_PRODUCT,
    ClaimRejectionReason_1.RejectionReason.CUSTOMER_INVOICE_NOT_PROVIDED,
];
//# sourceMappingURL=Constants.js.map